import type { LiveSessionResourceStateDto, TriggerEventInput } from '@/features/live/types';

/** Ressources occupant la scène : une seule peut être live à la fois, tous types confondus. */
const MEDIA_RESOURCE_TYPES = ['WEBINAR_SLIDE', 'WEBINAR_RESOURCE'];

/**
 * Ressources d'interaction : une seule peut être live à la fois, tous types confondus.
 * Les ressources partagées (Fichiers & Liens) font partie du même groupe d'exclusivité,
 * mais vivent dans un état séparé (state.webinar.currentSharedResources) : la coordination
 * inter-système est faite côté présentateur/modérateur (cf. SharedResourceLiveList + handleTriggerEvent).
 */
export const INTERACTION_RESOURCE_TYPES = ['SURVEY_TEMPLATE', 'QUIZ_TEMPLATE', 'OFFER_TEMPLATE'];

function exclusiveGroupOf(resourceType: string): string[] | null {
  if (MEDIA_RESOURCE_TYPES.includes(resourceType)) return MEDIA_RESOURCE_TYPES;
  if (INTERACTION_RESOURCE_TYPES.includes(resourceType)) return INTERACTION_RESOURCE_TYPES;
  return null;
}

/**
 * Ressources à masquer avant d'en lancer une : toutes celles du même groupe d'exclusivité,
 * sauf la ressource lancée (garde-fou si son état live est périmé).
 */
export function resourcesToHideOnShow(
  states: LiveSessionResourceStateDto[],
  event: TriggerEventInput,
): LiveSessionResourceStateDto[] {
  if (event.eventType !== 'RESOURCE_SHOW') return [];

  const group = exclusiveGroupOf(event.resourceType);
  if (!group) return [];

  return states.filter(
    (state) =>
      state.live &&
      group.includes(state.resourceType) &&
      !(state.resourceType === event.resourceType && state.resourceId === event.resourceId),
  );
}
